enum OrigemEmissao {
    EmissaoUnica = 1,
    EmissaoEmLote = 2,
}

export default OrigemEmissao;
